export default __webpack_public_path__ + "static/media/XzalorTitle.c6e32ab7.png";